// @ts-ignore
import React from "react";

import { IntercomProvider } from "@/libraries/intercom/src";
import { HomePageTemplate } from "@/templates/home/home-page/src/index";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const HomePage = () => {
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = checkFeatureFlagGate(
        featureFlags.gwp737EnableIntercomChatHome
    );

    return (
        <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
            <HomePageTemplate />
        </IntercomProvider>
    );
};
